import { ChamadoTecnicoAnexoService } from '@/features/chamados/services/chamado-tecnico-anexo.service'

import { Chamados } from '..'
import { EvidenceGallery } from '../evidencia/evidence-gallery'

type Props = {
  callId?: number
  isEditable?: boolean
}

export default function Component({ callId, isEditable }: Props) {
  return (
    <EvidenceGallery
      callId={callId}
      isEditable={isEditable}
      queryKey="callTechAttachment-gallery"
      repository={ChamadoTecnicoAnexoService}
      renderCreateDialog={({ onSuccess }) => (
        <Chamados.Tecnico.Evidencias.Adicionar_Dialog
          callId={Number(callId)}
          onSuccess={onSuccess}
        />
      )}
    />
  )
}
